import { render, staticRenderFns } from "./Mandants.vue?vue&type=template&id=fca4e7c6&scoped=true"
import script from "./Mandants.vue?vue&type=script&lang=js"
export * from "./Mandants.vue?vue&type=script&lang=js"
import style0 from "./Mandants.vue?vue&type=style&index=0&id=fca4e7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca4e7c6",
  null
  
)

export default component.exports